import { render, staticRenderFns } from "./EditarTurno.vue?vue&type=template&id=606a1782"
import script from "./EditarTurno.vue?vue&type=script&lang=js"
export * from "./EditarTurno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports